(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-cs10-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('af-cs10-comparison')) {
  customElements.define('af-cs10-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const scroller = this.querySelector('.afc-scroll');
      const arrows = this.querySelector('.afc-arrows');
      const buttons = [...arrows.querySelectorAll('button')];
      const more = this.querySelector('.afc-more');
      const extra = [...this.querySelectorAll('[data-extra="true"]')];
      let expanded = this.dataset.editor === 'true';
      const render = () => {
        extra.forEach(row => { row.hidden = !expanded; });
        more.hidden = !extra.length;
        more.setAttribute('aria-expanded', String(expanded));
        more.firstElementChild.textContent = expanded ? more.dataset.less : more.dataset.more;
        more.lastElementChild.textContent = expanded ? '−' : '+';
      };
      const updateArrows = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        arrows.hidden = max < 2;
        buttons[0].disabled = scroller.scrollLeft <= 2;
        buttons[1].disabled = scroller.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const width = this.querySelector('.afc-product').getBoundingClientRect().width;
        scroller.scrollBy({ left: Number(button.dataset.direction) * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      scroller.addEventListener('scroll', updateArrows, { ...options, passive: true });
      more.addEventListener('click', () => { expanded = !expanded; render(); }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { expanded = true; render(); }
      }, options);
      this.observer = new ResizeObserver(updateArrows);
      this.observer.observe(scroller);
      render(); updateArrows();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-eye-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('af-eye-comparison')) {
  customElements.define('af-eye-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const scroller = this.querySelector('.afe-scroll');
      const arrows = this.querySelector('.afe-arrows');
      const buttons = [...arrows.querySelectorAll('button')];
      const more = this.querySelector('.afe-more');
      const extra = [...this.querySelectorAll('[data-extra="true"]')];
      let expanded = this.dataset.editor === 'true';
      const render = () => {
        extra.forEach(row => { row.hidden = !expanded; });
        more.hidden = !extra.length;
        more.setAttribute('aria-expanded', String(expanded));
        more.firstElementChild.textContent = expanded ? more.dataset.less : more.dataset.more;
        more.lastElementChild.textContent = expanded ? '−' : '+';
      };
      const updateArrows = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        arrows.hidden = max < 2;
        buttons[0].disabled = scroller.scrollLeft <= 2;
        buttons[1].disabled = scroller.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const width = this.querySelector('.afe-product').getBoundingClientRect().width;
        scroller.scrollBy({ left: Number(button.dataset.direction) * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      scroller.addEventListener('scroll', updateArrows, { ...options, passive: true });
      more.addEventListener('click', () => { expanded = !expanded; render(); }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { expanded = true; render(); }
      }, options);
      this.observer = new ResizeObserver(updateArrows);
      this.observer.observe(scroller);
      render(); updateArrows();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-massage-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('af-massage-comparison')) {
  customElements.define('af-massage-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const scroller = this.querySelector('.afc-scroll');
      const arrows = this.querySelector('.afc-arrows');
      const buttons = [...arrows.querySelectorAll('button')];
      const more = this.querySelector('.afc-more');
      const extra = [...this.querySelectorAll('[data-extra="true"]')];
      let expanded = this.dataset.editor === 'true';
      const render = () => {
        extra.forEach(row => { row.hidden = !expanded; });
        more.hidden = !extra.length;
        more.setAttribute('aria-expanded', String(expanded));
        more.firstElementChild.textContent = expanded ? more.dataset.less : more.dataset.more;
        more.lastElementChild.textContent = expanded ? '−' : '+';
      };
      const updateArrows = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        arrows.hidden = max < 2;
        buttons[0].disabled = scroller.scrollLeft <= 2;
        buttons[1].disabled = scroller.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const width = this.querySelector('.afc-product').getBoundingClientRect().width;
        scroller.scrollBy({ left: Number(button.dataset.direction) * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      scroller.addEventListener('scroll', updateArrows, { ...options, passive: true });
      more.addEventListener('click', () => { expanded = !expanded; render(); }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { expanded = true; render(); }
      }, options);
      this.observer = new ResizeObserver(updateArrows);
      this.observer.observe(scroller);
      render(); updateArrows();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arboleaf-adaptive-banner"] && !Shopify.designMode) return;
  try {
    
  class AdaptiveBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.index = 0;
      this.timer = null;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.dataset.autoplay !== 'true';
      this.buttons.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.slideTo), true)));
      this.schedule();
    }
    show(index, manual) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === this.index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
      });
      if (manual) this.schedule();
    }
    stop() { window.clearTimeout(this.timer); }
    schedule() {
      this.stop();
      if (this.paused || this.slides.length < 2) return;
      const duration = Number(this.slides[this.index].dataset.duration) || 5000;
      this.timer = window.setTimeout(() => this.show(this.index + 1), duration);
    }
  }
  if (!customElements.get('adaptive-banner')) customElements.define('adaptive-banner', AdaptiveBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arboleaf-hover-panels"] && !Shopify.designMode) return;
  try {
    
  class ArbHoverPanels extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.defaultIndex = Math.min(
        Math.max(Number(this.dataset.defaultIndex) || 0, 0),
        Math.max(this.panels.length - 1, 0)
      );

      this.panels.forEach((panel, index) => {
        panel.addEventListener('pointerenter', () => {
          if (this.desktopQuery.matches && this.finePointerQuery.matches) this.activate(index);
        });

        panel.addEventListener('focusin', () => {
          if (this.desktopQuery.matches) this.activate(index);
        });

        panel.addEventListener('click', (event) => {
          if (!this.desktopQuery.matches || event.target.closest('a, button')) return;
          this.activate(index);
        });

        panel.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });

      this.addEventListener('pointerleave', () => {
        if (this.desktopQuery.matches && this.finePointerQuery.matches) this.activate(this.defaultIndex);
      });

      this.addEventListener('shopify:block:select', (event) => {
        const selectedPanel = event.target.closest('[data-panel]');
        if (!selectedPanel) return;
        this.activate(this.panels.indexOf(selectedPanel));
        if (!this.desktopQuery.matches) {
          selectedPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      this.activate(this.defaultIndex);
    }

    activate(index) {
      if (index < 0 || index >= this.panels.length) return;
      this.panels.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === index);
      });
    }

    handleKeydown(event, index) {
      if (!this.desktopQuery.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.panels.length) % this.panels.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.panels.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.panels.length - 1;
      this.activate(nextIndex);
      this.panels[nextIndex].focus();
    }
  }

  if (!customElements.get('arb-hover-panels')) {
    customElements.define('arb-hover-panels', ArbHoverPanels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["segmental-scales-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeShowcase = (root) => {
      if (!root || root.dataset.segmentalInitialized === 'true') return;

      const track = root.querySelector('[data-card-track]');
      const cards = Array.from(root.querySelectorAll('[data-card]'));
      const dots = Array.from(root.querySelectorAll('[data-card-dot]'));
      const mobileQuery = window.matchMedia('(max-width: 989px)');
      const previous = root.querySelector('[data-card-previous]');
      const next = root.querySelector('[data-card-next]');
      const count = root.querySelector('[data-card-count]');
      let activeIndex = 0;

      if (!track || cards.length < 2 || dots.length !== cards.length) {
        root.dataset.segmentalInitialized = 'true';
        return;
      }

      const cardScrollLeft = (card) => {
        const cardLeft = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        return previous
          ? cardLeft - parseFloat(getComputedStyle(track).paddingLeft)
          : cardLeft - (track.clientWidth - card.offsetWidth) / 2;
      };

      const setActiveDot = () => {
        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        activeIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(cardCenter - trackCenter);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
        if (previous && next && count) {
          previous.disabled = activeIndex === 0;
          next.disabled = activeIndex === cards.length - 1;
          const label = `${activeIndex + 1} / ${cards.length}`;
          if (count.textContent !== label) {
            count.textContent = label;
            count.setAttribute('aria-label', `Model ${activeIndex + 1} of ${cards.length}`);
          }
        }
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActiveDot();
          ticking = false;
        });
      }, { passive: true });

      const goToCard = (index) => {
        const destination = Math.max(0, Math.min(cards.length - 1, index));
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollTo({ left: cardScrollLeft(cards[destination]), behavior });
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => goToCard(index)));
      if (previous && next) {
        previous.addEventListener('click', () => goToCard(activeIndex - 1));
        next.addEventListener('click', () => goToCard(activeIndex + 1));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !mobileQuery.matches) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            goToCard(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
      }

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(setActiveDot);
        observer.observe(track);
      }

      window.requestAnimationFrame(() => {
        if (mobileQuery.matches) {
          const defaultIndex = 0;
          track.scrollTo({ left: cardScrollLeft(cards[defaultIndex]), behavior: 'auto' });
        }
        setActiveDot();
      });

      root.dataset.segmentalInitialized = 'true';
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-segmental-showcase]').forEach(initializeShowcase);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
